import { Box, Text } from '@chakra-ui/layout'
import { Button, Input, Spinner, useToast } from '@chakra-ui/react'
import { Layout } from 'components/atoms'
import { Icon } from 'components/atoms/Icon'
import { useAuthContext } from 'contexts/auth'
import { useContractContext } from 'contexts/contract'
import { useInstitutionsContext } from 'contexts/institutions'
import { environments } from 'environments/environments'
import { FormActions } from 'pages/Contracts/Components/StepsForm/styles'

import React, { useRef } from 'react'
import ServiceFee from 'services/fee'

interface SendingFilesProps {
    onClose: () => void
    onSubmit?: () => void
    tabIndex?: number
    isManagementFee?: boolean
    withSignature?: boolean
    toogleWithSignature?: (action: any) => void
}

const ModalBatchUpload: React.FC<SendingFilesProps> = ({
    onClose,
    tabIndex,
    isManagementFee,
    withSignature,
    toogleWithSignature
}) => {
    const { isBackoffice } = useAuthContext()
    const { currentInstitution } = useInstitutionsContext()
    const isLoteContracts = tabIndex === 1
    const toast = useToast()
    const toastSucess = useToast({ variant: 'solid-info' })

    const { loadingBatch, fileData, setLoadingBatch, postBatch, getLote } =
        useContractContext()

    const ref = useRef<HTMLInputElement>(null)

    const sendComputerFile = () => {
        ref.current?.click()
    }

    const convertToFormData = (data: File) => {
        const formdata = new FormData()

        if (isManagementFee) {
            formdata.append('file', data, data.name)
        } else {
            formdata.append('lote', data, data.name)
        }
        handleSubmit(formdata)
    }

    const formatIsValid = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files && event.target.files[0]
        const fileName = file && file.name
        const acceptedFormats = isManagementFee
            ? ['txt']
            : isLoteContracts
            ? ['csv', 'txt']
            : ['zip']

        const fileExt =
            fileName && fileName.substring(fileName.lastIndexOf('.') + 1)

        return fileExt && acceptedFormats.indexOf(fileExt) !== -1
    }

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (formatIsValid(event)) {
            const fileObj = event.target.files && event.target.files[0]

            event.target.value = ''

            fileObj && convertToFormData(fileObj)
        } else {
            toast({
                title: 'Sentimos muito!',
                description: 'Tipo de arquivo não permitido',
                position: 'bottom-left',
                status: 'error',
                isClosable: true
            })
        }
    }

    const fetchPostBatch = (data: FormData) => {
        if (tabIndex) {
            postBatch(data, tabIndex)
                .then(() => {
                    toastSucess({
                        title: 'Lote cadastrado com sucesso!',
                        description:
                            'Verifique o status de cada contrato na aba contratos.',
                        position: 'bottom-left',
                        status: 'info',
                        isClosable: true
                    })
                    getLote(
                        { pagina: 1, limite: 10 },
                        isBackoffice,
                        currentInstitution?.id as string,
                        tabIndex
                    )
                })
                .catch(err => {
                    toast({
                        title: 'Algo deu errado',
                        description: `${
                            err.response?.data.mensagem
                                ? err.response?.data.mensagem
                                : 'Ocorreu um erro, tente novamente mais tarde.'
                        }`,
                        position: 'bottom-left',
                        status: 'error',
                        isClosable: true
                    })
                })
                .finally(() => {
                    onClose && onClose()
                    setTimeout(() => {
                        setLoadingBatch(false)
                    }, 1000)
                })
        }
    }

    const fetchPostFee = async (data: FormData) => {
        try {
            await ServiceFee.uploadFee(data)
            toastSucess({
                title: 'Taxa(s) cadastrada(s) com sucesso!',
                description:
                    'Verifique o status de cada taxa na aba gestão de taxas.',
                position: 'bottom-left',
                status: 'info',
                isClosable: true
            })
        } catch (e: any) {
            toast({
                title: 'Algo deu errado',
                description: `${
                    e.response?.data.mensagem
                        ? e.response?.data.mensagem
                        : 'Ocorreu um erro, tente novamente mais tarde.'
                }`,
                position: 'bottom-left',
                status: 'error',
                isClosable: true
            })
        } finally {
            onClose && onClose()
            setTimeout(() => {
                setLoadingBatch(false)
            }, 1000)
        }
    }

    const handleSubmit = (data: FormData) => {
        if (isManagementFee) {
            fetchPostFee(data)
            return
        }
        fetchPostBatch(data)
    }

    const { SIGNATURE_ATTACHMENTS } = environments

    return (
        <Layout type="container" display="grid" data-testid="form-container">
            <Box
                display="flex"
                textAlign="center"
                alignItems="center"
                justifyContent="center"
                flexDirection="row"
                zIndex={12}
                mt="80px"
            >
                <Text
                    fontSize="20px"
                    whiteSpace="pre"
                    color="black"
                    fontWeight="700"
                >
                    {isManagementFee
                        ? 'Upload de Taxas'
                        : fileData?.anexo
                        ? 'Validação de Lote'
                        : 'Upload de lote'}
                </Text>
            </Box>
            <Box
                textAlign="center"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
                pt="104px"
                position="relative"
            >
                {!loadingBatch ? (
                    <>
                        <Box
                            pb="128px"
                            textAlign="center"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            flexDirection="column"
                            gap={2}
                            zIndex={12}
                            onClick={sendComputerFile}
                            cursor="pointer"
                        >
                            <Text
                                whiteSpace="pre"
                                color="black"
                                fontWeight="700"
                                mb="-8px"
                            >
                                Nenhum anexo selecionado.
                            </Text>
                            <Text
                                data-testid="text-file-lote"
                                whiteSpace="pre"
                                color="black"
                                fontWeight="700"
                                textDecoration="underline"
                                ref={ref}
                            >
                                Faça upload agora mesmo.
                            </Text>
                            <Input
                                data-testid="input-file-lote"
                                ref={ref}
                                type="file"
                                display={'none'}
                                accept={isLoteContracts ? '.csv,.txt' : '.zip'}
                                onChange={handleFileChange}
                            />
                            <Text
                                whiteSpace="pre"
                                color="black"
                                maxWidth="292px"
                                fontSize={12}
                            >
                                O arquivo deve possuir tamanho máximo de 5 Mb{' '}
                                <br /> (cinco megabytes),{' '}
                                {isManagementFee
                                    ? 'no formato TXT.'
                                    : isLoteContracts
                                    ? 'nos formatos CSV ou TXT.'
                                    : 'no formato .zip'}
                            </Text>
                            <Box
                                position="absolute"
                                zIndex="-1"
                                cursor="pointer"
                            >
                                <Icon name="file-alt-white" size={124} />
                            </Box>
                        </Box>
                    </>
                ) : (
                    <>
                        <Box
                            width="100%"
                            display="flex"
                            pb="86px"
                            alignItems="center"
                            flexDirection="column"
                            justifyContent="center"
                            top="0px"
                        >
                            <Text
                                pb="8px"
                                whiteSpace="pre"
                                color="black"
                                fontWeight="700"
                                fontSize="14px"
                            >
                                Fazendo upload
                            </Text>
                            <Text
                                whiteSpace="pre"
                                color="black"
                                fontSize="12px"
                            >
                                Não saia dessa tela até finalizar o upload
                            </Text>
                            <Spinner
                                mt="32px"
                                thickness="9px"
                                speed="0.65s"
                                emptyColor="gray.200"
                                color="primary"
                                size="xl"
                            />
                        </Box>
                    </>
                )}
            </Box>
            <Layout
                type="row"
                gutter={{ y: 1.5 }}
                data-testid="form-fields"
            ></Layout>
            <FormActions>
                <Button
                    data-testid="form-action-cancel"
                    colorScheme="primary"
                    variant={fileData?.anexo ? 'ghost' : 'solid'}
                    onClick={onClose}
                >
                    Cancelar
                </Button>
                {withSignature && SIGNATURE_ATTACHMENTS && (
                    <Button
                        colorScheme="primary"
                        type="submit"
                        onClick={toogleWithSignature}
                    >
                        Com assinatura
                    </Button>
                )}
            </FormActions>
        </Layout>
    )
}

export default ModalBatchUpload
